// Note: 兼容 nuxt 项目
// 一些会被提前编译的内容, 分包出来, 防止 Nuxt 报错 window is not define

import { ALL_FILE_TYPE, ALL_PLATFORM, AllType } from '@pikpak_web_player/components/errorPopup'

interface ErrorModule {
  title?: string
  subTitle?: string
  button?: string
}

const imgSrc2BlobUrl = async (src: string) => {
  try {
    if (!src || src === '') return ''

    const data = await (await fetch(src)).blob()
    return URL.createObjectURL(data)
  } catch (err) {
    console.error(err)
    return src
  }
}

const enum ImageErrorType {
  NETWORK_ERROR = 'IMAGE_NETWORK_ERROR',
  NOT_SUPPORT_IMAGE = 'NOT_SUPPORT_IMAGE',
}

interface ImageViewerProps {
  /** 文件 id */
  id?: string
  src?: string
  previewUrl?: string
  /** 每次缩进的倍率 */
  zoomRate?: number
  /** 缩进的最大倍率 */
  maxScale?: number
  /** 缩进的最小倍率 */
  minScale?: number
  initialDeg?: number
  initialWidth?: number
  initialHeight?: number
  preview?: boolean
  error?: {
    type?: ImageErrorType
    errorTitle?: string
    errorSubTitle?: string
    errorCode?: string
    showRetryButton?: boolean
    showNextButton?: boolean
  }
  scene?: string
}

const enum PlayErrorType {
  NETWORK_ERROR = 'NETWORK_ERROR',
  NOT_SUPPORT_VIDEO = 'NOT_SUPPORT_VIDEO',
  FREEZE_FILE = 'FREEZE_FILE',
  AUDIO_NETWORK_ERROR = 'AUDIO_NETWORK_ERROR',
  AUDIO_SUPPORT_ERROR = 'AUDIO_SUPPORT_ERROR',
}

interface AudioPlayerComponentProps {
  id: string
  src?: string
  author?: string
  coverUrl?: string
  preview?: boolean
  name?: string
  error?: {
    type?: PlayErrorType
    errorTitle?: string
    errorSubTitle?: string
  }
  scene?: string
}

export {
  ALL_FILE_TYPE,
  ALL_PLATFORM,
  AllType,
  ImageErrorType,
  imgSrc2BlobUrl,
  PlayErrorType,
  type AudioPlayerComponentProps,
  type ErrorModule,
  type ImageViewerProps,
}
